import type { AuthPort } from "../features/auth/auth-port";

const KEY = "cosmos.auth.reauth-at";
const WINDOW_MS = 30_000;

/** A 401 to a call that carried a token: sign in again, at most once per 30 s against loops. */
export async function reauthenticate(auth: Pick<AuthPort, "signIn">): Promise<boolean> {
  const now = Date.now();
  const last = Number(window.sessionStorage.getItem(KEY) ?? 0);
  if (now - last < WINDOW_MS) return false;
  window.sessionStorage.setItem(KEY, String(now));
  const { pathname, search, hash } = window.location;
  await auth.signIn(`${pathname}${search}${hash}`);
  return true;
}
